import { useInfiniteQuery } from 'react-query'
import {
    getMonyPoolsDetailTransactions,
    TFundTransactionType,
} from 'services/fund'

export default function useGetTransactions(
    id: string | undefined,
    searchTransaction: string,
    type: TFundTransactionType = '',
    /** one member's rows only — see getMonyPoolsDetailTransactions */
    poolship: number | null = null
) {
    const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
        useInfiniteQuery(
            ['money-pools-transactions', id, searchTransaction, type, poolship],
            ({ pageParam = 1 }) =>
                getMonyPoolsDetailTransactions(
                    id,
                    searchTransaction,
                    pageParam,
                    type,
                    poolship
                ),
            {
                // The server names no next page, only whether there is one, so
                // the next page is one past however many are already held.
                getNextPageParam: (lastPage, allPages) =>
                    lastPage?.results?.pagination?.has_next
                        ? allPages.length + 1
                        : undefined,
            }
        )

    return { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage }
}
